import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useApi } from "../../../api";
import { ICargo, ICoin, IExchange, IProfile, IReferral, ITransaction, ITransactionUsdt, IWallet } from "../../../interfaces";
import { WalletCard } from "./components/WalletCard"
import { Utils } from "../../../utils";
import { Form, InputGroup } from "react-bootstrap";
import { SuccessDialog } from "../../../components/SuccessDialog";
import { ErrorResponseDialog } from "../../../components/ErrorResponseDialog";
import { WalletTransaction } from "../../../components/NFT/Wallet/Transaction";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { InjectedCheckoutForm } from "../../../components/InjectedCheckoutForm";

import Modal from 'react-bootstrap/Modal';
import { WalletExchange } from "../../../components/NFT/Wallet/Exchange";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { ErrorDialog } from "../../../components/ErrorDialog";
import { Avatar, Box, useToast, Wrap, WrapItem } from "@chakra-ui/react";
import { WalletUsdtTransaction } from "../../../components/NFT/Wallet/UsdtTransaction";
import { useProjectCode } from "../../../hooks/useProjectCode";

const stripePromise = loadStripe(window.location.hostname === "localhost" ? 'pk_test_70OCDjwDvtq6KIznGEYCB9l8' : 'pk_live_8x88Bq3MeZPoybzdXtNMDMpl');

export const StoreWalletPage = () => {
  const projectCode = useProjectCode()
  const api = useApi(projectCode);
  const { t } = useTranslation();
  const toast = useToast();
  const [mounted, setMounted] = useState<Boolean>(false);
  const [selectedToken, setSelectedToken] = useState('GAS');

  const [referral, setReferral] = useState<IReferral>();
  const [coins, setCoins] = useState<ICoin>();
  const [ethWallet, setEthWallet] = useState<IWallet>();
  const [usdtWallet, setUsdtWallet] = useState<IWallet>();
  const [toAddress, setToAddress] = useState<string | null>(null);
  const [transferAmount, setTransferAmount] = useState<string | null>(null);
  const [otp, setOtp] = useState<string | null>(null);
  const [usdtTrxs, setUsdtTrxs] = useState<ITransactionUsdt[]>([]);
  const [ethTrxs, setEthTrxs] = useState<ITransaction[]>([]);
  const [gasTrxs, setGasTrxs] = useState<IExchange[]>([]);
  const [gasTopupTrxs, setGasTopupTrxs] = useState<IExchange[]>([]);
  const [nnegoTrxs, setNnegoTrxs] = useState<IExchange[]>([]);
  const [isProcessing, setProcessing] = useState(false);
  const [receiver, setReceiver] = useState<IProfile>();

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);


  const handleTransferResult = (cargo: ICargo) => {
    setProcessing(false)
    if (cargo.returnCode === '000000') {
      handleClose()
      SuccessDialog({ title: "交易指示已送出", content: "請於3~5分鐘後確認到帳情況" })
    } else {
      ErrorResponseDialog(cargo, t, projectCode);
    }
  }

  useEffect(() => {
    if (mounted) return;
    setMounted(true);
    Utils().checkKyc(projectCode);
    api.getReferralCode((cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setReferral(cargo.info);
      }
    })
    api.getCoinInfo((cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setCoins(cargo.info);
      }
    })
    api.getWallet("ETH", (cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setEthWallet(cargo.info[0]);
        api.getEthTransactions((cargo: ICargo) => {
          if (cargo.returnCode === '000000') {
            setEthTrxs(cargo.info);
          }
        })
      }
    })
    api.getWallet("USDT", (cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setUsdtWallet(cargo.info[0]);
        api.getUsdtTransactions((cargo: ICargo) => {
          if (cargo.returnCode === '000000') {
            setUsdtTrxs(cargo.info);
          }
        })
      }
    })
    api.getGasTransaction((cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setGasTrxs(cargo.info);
      }
    })
    api.getGasTopupTransaction((cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setGasTopupTrxs(cargo.info);
      }
    })
    api.getNnegoTransaction((cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setNnegoTrxs(cargo.info);
      }
    })
  }, [mounted, api, projectCode])

  const sendOtp = () => {
    api.sendOtp((cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        SuccessDialog({ title: "驗證碼發送成功", content: "請至信箱或LINE收取驗證碼" })
      } else {
        ErrorResponseDialog(cargo, t, projectCode);
      }
    })
  }

  return (
    <>
      <div className="px-3 py-4" style={{ background: '#f1f1f1' }}>
        <div className="">
          <div className="d-flex flex-wrap justify-center mx-auto" style={{ maxWidth: '900px' }}>
            <WalletCard
              title={t('gas')}
              token='GAS'
              accountNo={referral?.simpleCode}
              balance={coins?.gas}
              chainType={"Star River"}
              onClick={() => {
                setSelectedToken('GAS');
              }}
              onClickTransfer={() => {
                setShow(true);
              }}
            />
            <WalletCard
              title={t('nnego')}
              token='NNEGO'
              accountNo={referral?.simpleCode}
              balance={coins?.nonNegotiable}
              chainType={"Star River"}
              onClick={() => {
                setSelectedToken('NNEGO');
              }}
              onClickTransfer={() => {
                setShow(true);
              }}
            />
            <WalletCard
              title='USDT'
              token='USDT'
              accountNo={usdtWallet?.address}
              balance={usdtWallet?.balance}
              chainType={"TRC20"}
              onClick={() => {
                setSelectedToken('USDT');
              }}
              onClickTransfer={() => {
                setShow(true);
              }}
            />
            <WalletCard
              title='ETH'
              token='ETH'
              accountNo={Utils().normalizeHexAddress(ethWallet?.address)}
              balance={ethWallet?.balance}
              chainType={"Main Network"}
              onClick={() => {
                setSelectedToken('ETH');
              }}
              onClickTransfer={() => {
                setShow(true);
              }}
            />
          </div>

          <div className="rform bg-white mx-auto m-5" style={{ maxWidth: '1100px' }}>
            {
              gasTopupTrxs.length > 0 && <div className="weight-600 px-4 py-3 border-down">
                <span>儲值紀錄</span>
              </div>
            }
            <div className="">
              {gasTopupTrxs.length > 0 && <WalletExchange transactions={gasTopupTrxs}></WalletExchange>}
            </div>
            <div className="weight-600 px-4 py-3 border-down">
              <span>{t(selectedToken.toLocaleLowerCase())} 交易紀錄</span>
            </div>
            <div className="">
              {selectedToken === 'USDT' && usdtWallet && <WalletUsdtTransaction transactions={usdtTrxs} address={usdtWallet.address}></WalletUsdtTransaction>}
              {selectedToken === 'ETH' && ethWallet && <WalletTransaction transactions={ethTrxs} address={ethWallet.address}></WalletTransaction>}
              {selectedToken === 'GAS' && <WalletExchange transactions={gasTrxs}></WalletExchange>}
              {selectedToken === 'NNEGO' && <WalletExchange transactions={nnegoTrxs}></WalletExchange>}
            </div>
          </div>

          <div className="p-4"></div>

          <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton><div className="" style={{ width: '32px' }}></div>
              <Modal.Title className="d-flex">
                <img src={require(`../../../assets/img/nft/wallet/${selectedToken.toLocaleLowerCase()}.png`)} alt="icon" className="me-2" style={{ height: '30px' }} />
                {t(selectedToken.toLocaleLowerCase())}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-4">

              {
                selectedToken === 'GAS' && <div className="py-2">
                  <div className="text-left weight-600 mb-2">充值</div>
                  <div className="rform p-3">
                    <InputGroup>
                      <Form.Control
                        type="number"
                        placeholder={"請輸入充值金額"}
                        onChange={(e) => {
                          e.preventDefault();
                          setTransferAmount(e.target.value);
                        }}
                      />
                    </InputGroup>


                    <div className="rform p-3 mt-3">
                      <Elements stripe={stripePromise}>
                        <InjectedCheckoutForm projectCode={projectCode} product='topupGas' amount={Number(transferAmount) || 0} onSuccess={() => {

                        }} />
                      </Elements>
                    </div>
                  </div>
                </div>
              }
              {
                selectedToken === 'NNEGO' && <div className="py-2">
                  <div className="text-left weight-600 mb-2">提領</div>
                  <div className="rform p-3">
                    <InputGroup>
                      <Form.Control
                        type="number"
                        placeholder={"請輸入提領金額"}
                        onChange={(e) => {
                          e.preventDefault();
                          setTransferAmount(e.target.value);
                        }}
                      />
                    </InputGroup>
                    <div className="p-2"></div>
                    <InputGroup>
                      <Form.Control
                        type="number"
                        onChange={(e) => {
                          e.preventDefault();
                          setOtp(e.target.value);
                        }}
                      />
                      <InputGroup.Text className="cursor-pointer" onClick={sendOtp}>發送驗證碼</InputGroup.Text>
                    </InputGroup>
                    <div className="pt-4 flex justify-end">
                      <div className="bt-sell py-2" style={{ border: '1px solid #9b00ff' }}>
                        <span className="txt-16 weight-600" onClick={() => {
                          if (!usdtWallet?.address || !otp) return
                          api.requestNnegoToUsdt(
                            usdtWallet?.address,
                            Number(transferAmount),
                            otp,
                            (cargo: ICargo) => { handleTransferResult(cargo) }
                          )
                        }}>提領</span>
                      </div>
                    </div>
                  </div>
                </div>
              }
              <div className="py-2">
                {/* <Tabs
                  defaultActiveKey="send"
                  className="mb-3" 
                 fill
                >*/}
                <div className="weight-600 mb-2">轉出</div>
                <div className="rform p-3">
                  {
                    receiver && <div className="w-20 m-3">
                      <img className="rounded-full" src={Utils().normalizeImagePath(receiver.avator, projectCode)} alt={receiver.nickname} />
                    </div>
                  }
                  <InputGroup>
                    <Form.Control
                      type="text"
                      placeholder={(selectedToken === 'GAS' || selectedToken === 'NNEGO') ? "請輸入對方系統代碼" : "請輸入對方位址"}
                      onChange={(e) => {
                        e.preventDefault();
                        setToAddress(e.target.value);
                        if (e.target.value.length === 10) {
                          api.getPublicProfile(e.target.value, (cargo: ICargo) => {
                            if (cargo.returnCode === '000000') {
                              const profile: IProfile = cargo.info;
                              setReceiver(profile);
                              toast({
                                position: 'bottom-right',
                                duration: 15 * 1000,
                                render: () => (
                                  <Box color='white' p={3} bg='purple.600' rounded={"md"}>
                                    <Wrap>
                                      <WrapItem>
                                        <Avatar src={Utils().normalizeImagePath(profile.avator, projectCode)} />
                                      </WrapItem>
                                      <WrapItem>
                                        <div className="pl-3">{profile.nickname}</div>
                                      </WrapItem>
                                    </Wrap>
                                  </Box>
                                ),
                              })
                            }
                          })
                        }
                      }}
                    />
                  </InputGroup>
                  <div className="my-3">
                    <InputGroup>
                      <Form.Control
                        type="number"
                        placeholder={"請輸入轉出金額"}
                        onChange={(e) => {
                          e.preventDefault();
                          setTransferAmount(e.target.value);
                        }}
                      />
                    </InputGroup>
                  </div>
                  <InputGroup>
                    <Form.Control
                      type="number"
                      onChange={(e) => {
                        e.preventDefault();
                        setOtp(e.target.value);
                      }}
                    />
                    <InputGroup.Text className="cursor-pointer" onClick={sendOtp}>發送驗證碼</InputGroup.Text>
                  </InputGroup>
                  <div className="pt-4 flex justify-end">
                    <div className="bt-sell py-2" style={{ border: '1px solid #9b00ff' }} onClick={() => {
                      if (!selectedToken || !toAddress || !transferAmount || !otp) {
                        ErrorDialog({ title: '資料輸入不全' })
                        return;
                      }
                      setProcessing(true);
                      if (selectedToken === 'GAS') {
                        api.transferGas(toAddress, transferAmount, otp, (cargo: ICargo) => { handleTransferResult(cargo) })
                      }
                      if (selectedToken === 'NNEGO') {
                        api.transferNnego(toAddress, transferAmount, otp, (cargo: ICargo) => { handleTransferResult(cargo) })
                      }
                      if (selectedToken === 'USDT') {
                        api.transferUsdt(toAddress, transferAmount, otp, (cargo: ICargo) => { handleTransferResult(cargo) })
                      }
                    }}>
                      <span className="txt-16 weight-600">{isProcessing ? t('processing') : '轉出'}</span>
                    </div>
                  </div>
                </div>
                <div className="weight-600 my-2 mt-3">收款</div>
                <div>
                  {(selectedToken === 'GAS' || selectedToken === 'NNEGO') &&
                    <div>請將系統代碼提供給付款方：
                      <CopyToClipboard text={referral?.simpleCode || ''} onCopy={() => {
                        SuccessDialog({ title: t('copied') })
                      }}>
                        <span className="material-icons-outlined cursor-pointer" title="複製位址" style={{ verticalAlign: 'sub' }}>file_copy</span>
                      </CopyToClipboard>
                      <div>{referral?.simpleCode}</div>
                    </div>
                  }
                  {
                    (selectedToken === 'USDT' || selectedToken === 'ETH') &&
                    <div>請將位址提供給付款方：
                      <CopyToClipboard text={(selectedToken === 'USDT'
                        ? usdtWallet?.address
                        : Utils().normalizeHexAddress(ethWallet?.address)) || ''} onCopy={() => {
                          SuccessDialog({ title: t('copied') })
                        }}>
                        <span className="material-icons-outlined cursor-pointer" title="複製位址" style={{ verticalAlign: 'sub' }}>file_copy</span>
                      </CopyToClipboard>
                      <div style={{ wordBreak: 'break-word' }}>{
                        selectedToken === 'USDT'
                          ? usdtWallet?.address
                          : Utils().normalizeHexAddress(ethWallet?.address)
                      }</div>
                    </div>
                  }
                </div>
              </div>
            </Modal.Body>
          </Modal>

        </div>
      </div>
    </>
  )
}